import { toast } from "sonner"

// Plays a short two-tone chime via WebAudio. Best-effort: any failure (no
// AudioContext, autoplay policy) is swallowed so the visual alert still fires.
function playChime() {
  try {
    if (typeof window === "undefined") return
    const Ctx =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext
    if (!Ctx) return

    const ctx = new Ctx()
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.connect(gain)
    gain.connect(ctx.destination)

    osc.type = "sine"
    osc.frequency.value = 880
    gain.gain.setValueAtTime(0.2, ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.7)

    osc.start()
    osc.stop(ctx.currentTime + 0.7)
    osc.onended = () => void ctx.close()
  } catch {
    // best-effort — ignore audio failures
  }
}

// Requests notification permission lazily (on first timer start), never on page
// load. Safe when the Notification API is absent or the request rejects.
export async function ensureNotificationPermission(): Promise<void> {
  try {
    if (typeof Notification === "undefined") return
    if (Notification.permission === "default") {
      await Notification.requestPermission()
    }
  } catch {
    // ignore — alerts degrade to sound + toast
  }
}

// Alerts the user that a timer finished: chime + toast, plus a system
// notification when permission was granted (surfaces with the tab backgrounded).
export function fireTimerAlert(label: string): void {
  playChime()
  toast(`Timer done: ${label}`)

  try {
    if (
      typeof Notification !== "undefined" &&
      Notification.permission === "granted"
    ) {
      new Notification("Timer done", { body: label })
    }
  } catch {
    // ignore — toast already shown
  }
}
